<template>
  <nav class="sc-tabs mr-auto">
    <li
      class="sc-tab"
      v-for="(tab, index) in tabs"
      :key="index"
      :class="{ active: currentTab.name === tab.name }"
      v-if="tab.isShow"
      @click="changeTab(tab)"
    >
      {{ tab.name }}
    </li>
  </nav>
</template>

<script>
import moment from "moment";
import { PRIVILEGE } from "@/config/enums";

export default {
  props: ["activeTab", "privilege"],
  data() {
    return {
      tabs: [
        { key: "redeemList", name: "รายชื่อลงทะเบียน", isShow: true },
        { key: "processedList", name: "รายชื่อผู้โชคดี", isShow: false },
        { key: "usageList", name: "สถานะการใช้งาน", isShow: false }
      ]
    };
  },
  computed: {
    currentTab() {
      return this.tabs.find(tab => tab.key === this.activeTab) || this.tabs[0];
    }
  },
  watch: {
    "privilege.privilegeId": function watchPrivilageChange() {
      this.updateTabVisibility();
    }
  },
  methods: {
    changeTab(to) {
      this.$emit("changeTab", to.key);
    },
    updateTabVisibility() {
      if (this.privilege.type === PRIVILEGE.TYPE.IMMEDIATE) {
        this.tabs[0].isShow = false;
        this.tabs[1].isShow = true;
        this.changeTab(this.tabs[1]);

        if (
          this.privilege.usageType === PRIVILEGE.USAGE_TYPE.REDEEM &&
          moment(this.privilege.startUseDate).diff(moment(), "m") < 0
        ) {
          this.tabs[2].isShow = true;
        }
      }
      if (this.privilege.type === PRIVILEGE.TYPE.REGISTER) {
        if (moment(this.privilege.startActivateDate).diff(moment(), "m") < 0) {
          this.tabs[1].isShow = true;
        }
        if (moment(this.privilege.startUseDate).diff(moment(), "m") < 0) {
          this.tabs[2].isShow = true;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/admin/view/attendance/tabs.vue